import type { LucideIcon } from "lucide-react";
import { Rocket } from "lucide-react";

interface BuyerFeaturePageProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  badge?: string;
}

/**
 * Placeholder page for buyer sidebar features that are not yet implemented.
 * Renders a polished empty state so the route exists and links resolve.
 */
export default function BuyerFeaturePage({
  title,
  description,
  icon: Icon = Rocket,
  badge,
}: BuyerFeaturePageProps) {
  return (
    <div className="public-stage pb-8">
      <div className="w-full px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center gap-3">
          <h1 className="font-display text-2xl font-extrabold text-foreground sm:text-3xl">
            {title}
          </h1>
          {badge && (
            <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-wide text-primary">
              {badge}
            </span>
          )}
        </div>

        <div className="flex flex-col items-center justify-center rounded-[1.35rem] border border-dashed border-border bg-card/60 px-6 py-20 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Icon className="h-8 w-8" />
          </div>
          <h2 className="mt-5 text-lg font-bold text-foreground">Coming soon</h2>
          <p className="mt-2 max-w-md text-sm leading-7 text-muted-foreground">
            {description ??
              "We're building this experience for you. Check back shortly — it'll be ready soon."}
          </p>
        </div>
      </div>
    </div>
  );
}
